'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = undefined;
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var propTypes = exports.propTypes = {
  label: _propTypes2.default.string.isRequired,
  text: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  href: _propTypes2.default.string,
  error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  value: _propTypes2.default.string,
  hasError: _propTypes2.default.bool,
  withCallout: _propTypes2.default.bool,
  linkUnderline: _propTypes2.default.bool,
  maxLength: _propTypes2.default.number,
  onChange: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  disabled: _propTypes2.default.bool,
  icon: _propTypes2.default.func,
  style: _propTypes2.default.object,
  // eslint-disable-line
  mask: _propTypes2.default.string,
  testID: _propTypes2.default.string,
  accessibilityLabel: _propTypes2.default.string,
  errorPlaceHolderWihoutHeight: _propTypes2.default.bool,
  type: _propTypes2.default.oneOf(['email', 'password', 'search', 'tel', 'text'])
};
var defaultProps = exports.defaultProps = {
  hasError: false,
  withCallout: false,
  maxLength: 255,
  errorPlaceHolderWihoutHeight: false,
  type: 'text'
};